import axios from "axios";
import { RunConfigService, ConfigService } from "@nuskin/ns-util";

/**
 * Used to retrieve market header config from local storage (if exists) or
 * market header service.
 * @param {string} page The url pathname Ex: "/content/nuskin/en_US/home.html"
 * @param {string} siteUrl The url origin Ex: "https://test.nuskin.com"
 * @param {string} selector the property of MarketHeaderData to return. One of
 * ["displayPage", "logo", "market", "miniCart", "page", "profile",
 * "searchResultsPage", "searchbar", "testUseNew"]
 * @returns Promise<data>
 */
async function getMarketHeaderData(page, siteUrl, mySiteOverride, selector) {
  let marketHeaderData = await getMarketHeaderDataFromService(
    page,
    siteUrl,
    mySiteOverride
  );
  return selector ? marketHeaderData[selector] : marketHeaderData;
}

/**
 * Retrieve market header data from AEM service
 * @returns {} - header data
 * @private
 */
async function getMarketHeaderDataFromService(page, siteUrl, mySiteOverride) {
  const marketConfig = ConfigService.getMarketConfig();
  const runConfig = RunConfigService.getRunConfig();
  const configSiteUrl = marketConfig.siteUrl;
  const selectors = `${runConfig.language}_${runConfig.country}${
    mySiteOverride ? ".mySiteOverride" : ""
  }`;

  let marketHeaderDataUrl =
    `${siteUrl ? siteUrl : configSiteUrl}` +
    `/apps/hello/services/marketheader.` +
    `${selectors}.json` +
    `${page}.json`;
  try {
    const marketHeaderDataResponse = await axios.request({
      method: "get",
      url: marketHeaderDataUrl,
      responseType: "json"
    });
    return marketHeaderDataResponse.data;
  } catch (err) {
    marketHeaderDataUrl =
      `${configSiteUrl}` +
      `/apps/hello/services/marketheader.` +
      `${selectors}.json` +
      `${page}.json`;
    try {
      const marketHeaderDataResponse = await axios.request({
        method: "get",
        url: marketHeaderDataUrl,
        responseType: "json"
      });
      return marketHeaderDataResponse.data;
    } catch (err) {
      console.log(
        "Could not retrieve header data: " +
          (err.response ? err.response.status : err)
      );
      return {};
    }
  }
}

export default {
  getMarketHeaderData
};
